import { fetchOperation, getOperation, fetchMaster } from "utils/api";

export const queryStatementList = async (params) => {
  return await getOperation("/statement/list", {
    ...params,
  });
};

export const showStatementPdf = async (params) => {
  return await fetchOperation("/statement/presign", {
    ...params,
  });
};

export const generateStatementPdf = async (params) => {
  return await fetchMaster("/statement/pdf-generate", {
    ...params,
  });
};
